// extracted by mini-css-extract-plugin
module.exports = {"arrow":"ArrowInCircle_arrow__UaqXL","inverted":"ArrowInCircle_inverted__TKFu2"};